// extracted by mini-css-extract-plugin
export default {"products":"_u-z","card":"av-z","oosMessaging":"bv-z"};